import { ApiClient } from './client/ApiClient.js';
import { Com } from './client/com/Com.js';
import { Pro } from './client/pro/Pro.js';
import { V1 } from './client/v1/V1.js';

class Packlink {
  constructor(apiConfig, application, requestContext, packlinkAuth, tenant, applicationVersion) {
    this.apiConfig = apiConfig;
    this.application = application;
    this.requestContext = requestContext;
    this.packlinkAuth = packlinkAuth;
    this.tenant = tenant;
    this.applicationVersion = applicationVersion;
    this.apiClient = new ApiClient(this.apiConfig, this.application, this.requestContext, this.packlinkAuth, this.tenant, this.applicationVersion);
    this.com = new Com(this.apiClient);
    this.pro = new Pro(this.apiClient);
    this.v1 = new V1(this.apiClient);
  }
  getAuthorization() {
    return this.packlinkAuth;
  }
  getTenant() {
    return this.tenant || this.apiClient.getTenant();
  }
  getApplication() {
    return this.application;
  }
  getRequestContext() {
    return this.requestContext;
  }
  setAuthorization(packlinkAuth) {
    this.packlinkAuth = packlinkAuth;
    this.apiClient.setAuthorization(packlinkAuth);
  }
  setRequestContext(requestContext) {
    this.requestContext = requestContext;
    this.apiClient.setRequestContext(requestContext);
  }
  setTenant(tenant) {
    this.apiClient.setTenant(tenant);
    this.tenant = tenant;
    this.requestContext = this.apiClient.getRequestContext();
  }
}

export { Packlink };
//# sourceMappingURL=Packlink.js.map
